<template>
  <div id="app" @click="isDo()">
    <router-view />
  </div>
</template>
<script>
import store from "@/store";
export default {
  data() {
    return {
      lastTime: null, //最后一次点击的时间
      currentTime: null, //当前点击的时间
      timeOut: 180 * 60 * 1000, //设置超时时间： 三小时
    };
  },
  computed: {},
  watch: {},
  methods: {
    isDo() {
      this.currentTime = new Date().getTime(); //记录这次点击的时间
      // console.log(this.currentTime - this.lastTime, this.timeOut);
      if (this.currentTime - this.lastTime > this.timeOut) {
        //判断上次最后一次点击的时间和这次点击的时间间隔是否大于10分钟
        // 这里写状态已过期后执行的操作
        store.dispatch("LogOut").then(() => {
          // 调用解绑微信接口
          location.href = "/login";
        });
      } else {
        this.lastTime = new Date().getTime(); //如果在10分钟内点击，则把这次点击的时间记录覆盖掉之前存的最后一次点击的时间
      }
    },
  },
  created() {
    this.lastTime = new Date().getTime(); //网页第一次打开时，记录当前时间
  },
};
</script>
<style lang="scss">
* {
  margin: 0;
  padding: 0;
  // user-select: none;
  // -ms-user-select: none;
}
ul,
li {
  list-style: none;
}

body {
  font-family: PingFangSC-Medium, PingFang SC;
}
#app {
  width: 100vw;
  height: 100vh;
}

//滚动条样式
::-webkit-scrollbar {
  width: 12px;
  height: 4px;
}

::-webkit-scrollbar-thumb {
  border-radius: 12px;
  border: 2px solid rgba(0, 0, 0, 0);
  box-shadow: -10px 0 0 #c7c7c7 inset;
  transition: 0.3s;
  &:hover {
    box-shadow: -10px 0 0 #878787 inset;
  }
}
//选中效果
// ::selection {
//   background: rgba(32, 178, 170, 0.6);
//   color: #ffffff;
// }

// ::-moz-selection {
//   background: rgba(32, 178, 170, 0.6);
//   color: #ffffff;
// }
</style>
